import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-III',
    templateUrl: './rs005-card-III.component.html'
})

export class Rs005CardIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Amostra na Esteira Transportadora', false);
        if(this.isBasica || this.isComercial){
            this.formulario = this.formBuilder.group({
                Status_wwb: [null, []],
                Peso_amostra_g: [null, []],
                Peso_palha_imp_g: [null, []],
                Peso_graos_debulhados_g: [null, []],
                Peso_graos_espigas_inteiras_g: [null, []],
                Palha_cerar: [null, []],
                Sabugo_cerar: [null, []],
                Semente_cerar: [null, []],
                Palha_amostra: [null, []],
                Total_graos_perdidos_amostra: [null, []],
                Perda_por_espigas_inteiras: [null, []],
            });
        }
        else if(this.isPreBasica){
            this.formulario = this.formBuilder.group({
                ataque_lagartas: [null, [Validators.required]],
                diploidia: [null, [Validators.required]],
                fusarium: [null, [Validators.required]],
                ataque_besouros: [null, [Validators.required]],
                viviparidade: [null, [Validators.required]],
                giberela: [null, [Validators.required]],
                mortas: [null, [Validators.required]],
                popped_kernel: [null, [Validators.required]],
                ponto_dupla: [null, [Validators.required]],
                comentarios: [null, []]
            });
            this.step = 'Defeitos (em 100 espigas selecionadas)'
        }
          
    }

    public async ngOnInit(): Promise<void> {
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async getQua007Data(): Promise<void> {
        const cerar = this.formulario.get('cerar')?.value as string;
        if (!!cerar) {
            await this.formularioService.getQua007Data(cerar).toPromise().then((objQua007: any) => {
                this.formulario.get('Status_wwb').setValue(objQua007?.data?.status_wwb);
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }
}

